import React from 'react'
import styled from 'styled-components'

const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

const MenuItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`

const Label = styled.span`
  font-family: "Proxima-Nova";
  font-size: 14px;
  letter-spacing: 0.308px;
}
`

export const PlaylistMenus = ({ menuOptions }) => {
  return (
    <MenuContainer>
      {menuOptions.map((item, index) => {
        const IconComponent = item.icon
        return (
          <MenuItem key={index}>
            <IconButton onClick={() => item.handleClick()}>
              <IconComponent />
            </IconButton>
            <Label>{item.text}</Label>
          </MenuItem>
        )
      })}
    </MenuContainer>
  )
}
